import { render } from "./fbSvg.vue?vue&type=template&id=4c4a3ec8&scoped=true"
import script from "./fbSvg.vue?vue&type=script&lang=js"
export * from "./fbSvg.vue?vue&type=script&lang=js"

import "./fbSvg.vue?vue&type=style&index=0&id=4c4a3ec8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c4a3ec8"]])

export default __exports__